import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  PasswordInput,
  ScrollArea,
  Select,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { CREATE_DRIVER } from "apollo/mutuations";
import { GET_REGIONS } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
// import Map from "components/utilities/Map";
import { useState } from "react";

export const DriverAddModal = ({
  setOpened,
  total,
  setTotal,
  activePage,
  setActivePage,
  size,
  fetchData,
}) => {
  // state variables
  const [regionsDropDownData, setRegionsDropDownData] = useState([]);
  // state variable to handle map location
  // const [location, setLocation] = useState({});

  // form state
  const form = useForm({
    initialValues: {
      name: "",
      city: "",
      phone: "",
      region: "1",
      email: "",
      password: "",
      password_confirmation: "",
    },
    validate: {
      phone: (value) =>
        value.length > 13 || value.length < 10
          ? "Phone number must be exactly 13 characters"
          : null,
      password_confirmation: (value, values) =>
        value !== values.password ? "Passwords do not match" : null,
    },
  });

  // mutation
  const [addDriver, { loading: driverLoading }] = useMutation(CREATE_DRIVER, {
    update(cache, { data: { createDriver } }) {},
  });

  // graphql queries
  const { loading: regionsLoading } = useQuery(GET_REGIONS, {
    variables: {
      first: 100000,
      page: 1,
    },
    onCompleted(data) {
      let regions = data.regions;
      let regionsArray = [];

      // loop over regions data to structure the data for the use of drop down
      regions.data.forEach((region, index) => {
        regionsArray.push({
          label: region?.name,
          value: region?.id,
        });
      });

      // put it on the state
      setRegionsDropDownData([...regionsArray]);
    },
    onError(err) {
      showNotification({
        color: "red",
        title: "Error",
        message: `${err}`,
      });
    },
  });

  const { height } = useViewportSize();

  const submit = () => {
    addDriver({
      variables: {
        name: form.getInputProps("name").value,
        city: form.getInputProps("city").value,
        region_id: form.getInputProps("region").value,
        phone: form.getInputProps("phone").value,
        email: form.getInputProps("email").value,
        password: form.getInputProps("password").value,
        password_confirmation: form.getInputProps("password_confirmation")
          .value,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Driver Created Successfully",
        });
        fetchData(size, activePage);
        setOpened(false);
      },
      onError(error) {
        setOpened(true);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to create driver",
        });
      },
    });
    // e.preventDefault();
  };

  // set the selected value to the form state
  const setRegionDropDownValue = (val) => {
    form.setFieldValue("region", val);
  };

  return (
    <>
      <LoadingOverlay
        visible={regionsLoading || driverLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Name"
                  placeholder="Name"
                  {...form.getInputProps("name")}
                />
                <TextInput
                  required
                  label="Phone"
                  type="number"
                  placeholder="Phone"
                  {...form.getInputProps("phone")}
                />
                <TextInput
                  required
                  label="Email"
                  placeholder="Email"
                  {...form.getInputProps("email")}
                />
                <Select
                  data={regionsDropDownData}
                  value={form.getInputProps("region")?.value.toString()}
                  onChange={setRegionDropDownValue}
                  label="Region"
                  placeholder="Pick a region this retailer belongs to"
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <PasswordInput
                  placeholder="Password"
                  label="Password"
                  // description="Password must include at least one letter, number and special character"
                  {...form.getInputProps("password")}
                />
                <PasswordInput
                  placeholder="Confirm Password"
                  label="Confirm Password"
                  // description="Password must the samer"
                  {...form.getInputProps("password_confirmation")}
                />
                <TextInput
                  required
                  label="City"
                  placeholder="City"
                  {...form.getInputProps("city")}
                />
              </Grid.Col>
            </Grid>

            <Grid>
              <Grid.Col span={6}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "15px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};
